import React from "react";
import "./PageNotFound.scss";
import { Link } from "react-router-dom";

export default function PageNotFound() {
  return (
    <div className="pageNotFound-container">
      <div className="container flex justify-items-center items-center gap-5 p-5 mx-auto my-auto h-full">
        <div className="grid grid-cols-1 gap-6 max-w-4xl mx-auto">
          <div className="flex justify-center items-center mb-6">
            <img
              src="/assets/logo/logo.png"
              className="object-contain md:h-14 h-12"
              alt="logo"
            />
          </div>
          <div className="flex justify-center items-center">
            <img
              src="/assets/images/pageNotfound.png"
              alt=""
              className="w-[35rem] p-4"
            />
          </div>
          <div className="text-center">
            <p className="font-bold text-[#2F2B3D] sm:text-5xl text-xl">
              Oops! Something went wrong
            </p>
            <p className="mt-2 text-base">
              We can’t seem to find a page you are looking for
            </p>
          </div>
          <div className="flex justify-center items-center">
            <Link
              to={"/dashboard"}
              className="text-center text-base font-medium py-3 px-8 rounded-lg text-white bg-primary themeHover "
            >
              Go To Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
